import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { axiosWithoutHeader } from "../api/axios";

import { Toast } from "primereact/toast";

import { useFormik } from "formik";
import { MuiTelInput } from "mui-tel-input";
import { MuiOtpInput } from "mui-one-time-password-input";
import {
  TextField,
  Button,
  Grid,
  CircularProgress,
  Box,
  Typography,
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import Swal from "sweetalert2";
import loader from "../utils/Helper";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from "@mui/material/Slide";
import "./Login.css";

const SIGNUP_URL = "/account/signup";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const validationRules = {
  username: {
    required: "Username is required",
    pattern: /^[a-zA-Z][a-zA-Z0-9_.]{7,19}$/,
    message:
      "Username must start with a letter and be 8 to 20 characters long. You can use letters, numbers, underscores, or periods.",
  },
  email: {
    required: "Email is required",
    pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    message: "Invalid email address",
  },
  phone: {
    required: "Phone is required",
    pattern: /.{10,}/,
    message: "Invalid phone number",
  },
  otp: {
    required: "OTP is required",
    pattern: /^[0-9]{6}$/, // Adjust the pattern as needed
    message: "",
  },
};
const initialValues = {
  username: "",
  email: "",
  phone: "",
  otp: "",
  phoneinfo: null
};
const validateChar = (value, index) => {
  return /^\d$/.test(value);
};
const SignUpContainer = ({ throughAdmin = false }) => {
  const [focusedField, setfocusedField] = useState();
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [resendOtp, setresendOtp] = useState(false);
  const [countdown, setCountdown] = useState(0); // Countdown timer
  const [currentStep, setCurrentStep] = useState(1);
  const [btnDisable, setbtnDisable] = useState(true);
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState(false);
  const [message, setMessage] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    if (resendOtp) {
      formik.setFieldValue("otp", "");

      formik.handleSubmit();
    }
  }, [resendOtp]);
  useEffect(() => {
    let timer = null;

    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    } else {
      clearInterval(timer);
    }

    return () => {
      clearInterval(timer);
    };
  }, [countdown]);

  const validate = (values) => {
    const errors = {};
    // OTP validation
    if (currentStep == 2 && !resendOtp) {
      if (!values.otp) {
        errors.otp = validationRules["otp"].required;
        setbtnDisable(true);
      } else if (!validationRules["otp"].pattern.test(values.otp)) {
        errors.otp = validationRules["otp"].message;
        setbtnDisable(true);
      } else {
        setbtnDisable(false);
      }
    }

    // Phone validation
    if (!values.phone) {
      const rules = validationRules["phone"];

      errors.phone = rules.message;
    }
    else if (values.phoneinfo && !values.phoneinfo.nationalNumber.length) {
      const rules = validationRules["phone"];

      errors.phone = rules.message;
    }

    // Email validation
    if (!values.email) {
      errors.email = validationRules["email"].required;
    } else if (!validationRules["email"].pattern.test(values.email)) {
      errors.email = validationRules["email"].message;
    }
    // username validation
    if (!values.username) {
      errors.username = validationRules["username"].required;
    } else if (!validationRules["username"].pattern.test(values.username)) {
      errors.username = validationRules["username"].message;
    }

    currentStep == 1 && setbtnDisable(Boolean(Object.keys(errors).length));
    return errors;
  };
  const formik = useFormik({
    initialValues: {
      ...initialValues,
      currentStep,
      resendOtp,


    },
    validate,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values) => {
      !resendOtp && setLoading(true);
      const postData =
        currentStep == 1 || resendOtp
          ? {
            username: values.username,
            email: values.email,
            phone: values.phone,
            isAdmin: throughAdmin,
          }
          : {
            username: values.username,
            email: values.email,
            phone: values.phone,
            otp: values.otp,
            isAdmin: throughAdmin,
          };

      try {
        const response = await axiosWithoutHeader.post(SIGNUP_URL, postData);
        if (response.status === 200) {
          if (currentStep == 1 || resendOtp) {
            setOpen(true);
            setSeverity('success');
            setMessage('OTP sent successfully');
            setCountdown(30);
            setbtnDisable(true);
            currentStep == 1 && setCurrentStep(2);
          } else {
            setOpen(true);
            setSeverity('success');
            setMessage(throughAdmin ? "User has been register successfully": "Please log in to continue");

            setCurrentStep(3);
            // formik.resetForm();
            if (throughAdmin) {

              Swal.fire({
                title: "Add more user?",
                text: "Do you want to add more user!",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
              }).then((result) => {
                if (result.isConfirmed) {
                  setCurrentStep(1)
                  formik.resetForm();
                } else {

                  navigate("/dashboard");


                }
              });
            };
          }
        } else {
          setOpen(true);
          setSeverity('error');
          setMessage(response.data.error);
        }
      } catch (err) {
        if (err && err?.response?.status == 400) {
          const errorMsg = err.response.data.error;
          if (errorMsg.includes("Username")) {
            setbtnDisable(true);
            formik.setFieldError("username", errorMsg);
          } else if (errorMsg.includes("Email")) {
            setbtnDisable(true);
            formik.setFieldError("email", errorMsg);
          } else if (errorMsg.includes("OTP")) {
            formik.setFieldError("otp", errorMsg);

          } else {
             setOpen(true);
              setSeverity('error');
              setMessage(err.response.data.error);
          }
        } else {
          setOpen(true);
          setSeverity('error');
          setMessage(err.response.data.error);
        }
      } finally {
        setLoading(false);
        setresendOtp(false);
      }
    },
  });

  const handleClose = async () => {
    setOpen(false);
  };

  return (
    <>
     <Snackbar
      open={open}
      autoHideDuration={8000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      TransitionComponent={SlideTransition}
    >
      <Alert
        onClose={handleClose}
        severity= {severity}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {message}
      </Alert>
    </Snackbar>
      {/* {currentStep === 1 && !throughAdmin && <>  <p className="p-relative loginTxt">
        Have an account? <Link to="/">Sign In</Link>
      </p>
      </>
      }
      {!throughAdmin && currentStep != 3 && <><h4 className="text-align-center">Welcome</h4>
        <p className="text-align-center">
          One-stop platform for comprehensive tax solutions

        </p></>} */}
      <div className="text-align-center">
        <h4>{currentStep === 3 ? "Registration Successful" : ""}</h4>
      </div>
      <form onSubmit={formik.handleSubmit}>
        {currentStep === 1 && (
            <>
           <div class="input-wrap">
              <TextField
                  id="username"
                  name="username"
                  label="Username"
                  fullWidth
                  className="custom-inputField mbtm"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  autoFocus={focusedField === "username"}
                  onBlur={formik.handleBlur("username")}
                  error={
                    formik.touched.username && Boolean(formik.errors.username)
                  }
                  helperText={formik.touched.username && formik.errors.username}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />

               <TextField
                id="email"
                name="email"
                label="Email"
                className="custom-inputField mbtm"
                fullWidth
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur("email")}
                autoFocus={focusedField == "email"}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                InputLabelProps={{
                  shrink: true,
                }}
              />

              <MuiTelInput
                forceCallingCode
                className="custom-inputField "
                label="Phone"
                autoFocus={focusedField == "phone"}
                fullWidth
                onBlur={formik.handleBlur("phone")}
                defaultCountry="IN"
                value={formik.values.phone}
                onChange={(value, info) =>
                  formik.setValues({
                    ...formik.values,
                    phoneinfo: info,
                    phone: value.replace(/\s+/g, "")
                  })
                }
                error={formik.touched.phone && Boolean(formik.errors.phone)}
                helperText={formik.touched.phone && formik.errors.phone}
              />
           </div>

            <Button
                type="submit"
                variant="contained"
                className="btn btn-primary btn-h w-100 submitbutton"
                disabled={btnDisable}
              >
                {loading ? (
                  <CircularProgress size={20} style={{ marginRight: "5px" }} />
                ) : (
                  "GET OTP"
                )}
              </Button>
          </>
        )}

        {currentStep === 2 && (
          <Grid
            container
            spacing={4}
            marginTop={"15px"}
            justifyContent={"center"}
          >
            <Grid item xs={12}>
              <p className="text-align-center">
                {
                  throughAdmin ? "OTP has been sent to Admin email id/phone number" : "OTP has been sent to registered email id/phone number"
                }
              </p>
              <InputLabel htmlFor="otp-input">Please enter OTP </InputLabel>
              <MuiOtpInput
                length={6}
                name="otp"
                autoFocus
                validateChar={validateChar}
                value={formik?.values?.otp}
                onChange={(value) => formik.setFieldValue("otp", value)}
                className="custom-otpfield"
                InputLabelProps={{
                  id: "otp-input",
                  "aria-labelledby": "otp-input-label",
                }}
              />

              {formik.touched.otp && formik.errors.otp ? (
                <div
                  style={{
                    alignItems: "flex-start",
                    marginBottom: "10px",
                    marginTop: "10px",
                    display: "flex",
                  }}
                  className="text-danger"
                >
                  {formik.errors.otp}
                </div>
              ) : null}
              <div className="countdown-text">
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                >
                  {countdown > 0 ? (
                    <p>
                      Resend OTP in : 00:
                      {countdown < 10 ? `0${countdown}` : countdown}
                    </p>
                  ) : (

                    <Button
                      variant="text"
                      onClick={() => {
                        setresendOtp(true);
                      }}
                      style={{
                        height: "14px",
                        textTransform: "capitalize",
                        font: "12px",
                      }}
                    >
                      {resendOtp ? (
                        <CircularProgress
                          size={20}
                          style={{ marginRight: "5px" }}
                        />
                      ) : (
                        "Resend OTP"
                      )}
                    </Button>


                  )}
                  <Button
                    variant="text"
                    style={{
                      height: "14px",
                      textTransform: "capitalize",
                      font: "12px",
                    }}

                    onClick={() => {
                      formik.setFieldValue("otp", "");
                      setCountdown(0);
                      setCurrentStep(1);
                      setfocusedField("phone");
                      setbtnDisable(false);
                    }}
                  >
                    Change Phone Number
                  </Button>
                </Box>
              </div>
            </Grid>
            <Grid item xs={8}>
              <Button
                type="submit"
                variant="contained"
                className="btn btn-primary btn-h w-100 otp-button"
                disabled={btnDisable}
              >
                {loading ? (
                  <CircularProgress size={20} style={{ marginRight: "5px" }} />
                ) : throughAdmin ? (
                  "Register"
                ) : (
                  "Get Started"
                )}
              </Button>
            </Grid>
          </Grid>
        )}
        {currentStep === 3 && (
          <Box sx={{ marginTop: "25px" }} textAlign={"center"}>
            {throughAdmin ? (
              <Typography>User has been registered successfully</Typography>
            ) : (
              <Box sx={{ marginTop: "50px" }} textAlign={"center"}>

                <Typography fontSize={18}>
                  Account has been successfully registered,click{" "}
                  <Link to="/">here</Link> to login.
                </Typography>
                <Typography fontSize={18} sx={{ marginTop: "25px" }}>
                  Please check your email for your login details, which have been sent to <strong>{formik.values.email}</strong>
                </Typography>
              </Box>

            )}
          </Box>
        )}
      </form>
      <Toast ref={toast} position="top-center" />
    </>
  );
};

export default SignUpContainer;
